export default __webpack_public_path__ + "static/media/virus-2.8cd3b156.svg";